module.exports = __webpack_public_path__ + "static/media/theTrapQ.ad716b76.svg";